import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n/I18nContext.jsx';
import { useLocalizedPath } from '../hooks/useLocalizedPath.js';
import PageMeta from '../components/PageMeta.jsx';
import LobsterMascot from '../components/LobsterMascot.jsx';
import PublicNav from '../components/PublicNav.jsx';
import PublicFooter from '../components/PublicFooter.jsx';

export default function NotFoundPage() {
  const { t } = useTranslation();
  const lp = useLocalizedPath();

  return (
    <>
      <PageMeta
        title={t('notFound.meta.title')}
        description={t('notFound.meta.description')}
        path="/404"
      />

      <div className="pub-page">
        <PublicNav />

        <main id="main-content" className="not-found-page">
          <div className="not-found-inner">
            <LobsterMascot size={120} aria-hidden="true" />
            <h1 className="not-found-title">{t('notFound.title')}</h1>
            <p className="not-found-sub">{t('notFound.sub')}</p>
            <Link to={lp('/')} className="btn btn-primary btn-lg">
              {t('notFound.backHome')}
            </Link>
          </div>
        </main>

        <PublicFooter />
      </div>
    </>
  );
}
